function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { ClipboardPermissionsDeniedError, ClipboardUnavailableError } from "./errors/index.js";
import UnsupportedPermissionError from "./errors/UnsupportedPermissionError.js";
import { checkPermission } from "./PermissionUtils.js";
/**
 * Copy the passed in text to the clipboard.
 * @param text The text to copy
 * @returns Promise Resolved on success, rejected on failure
 */
export function copyToClipboard(_x) {
  return _copyToClipboard.apply(this, arguments);
}

/**
 * Copy the passed in text to the clipboard using the `execCommand` functionality
 * Throws on error/failure
 * @param text The text to copy
 */
function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator(function* (text) {
    var _navigator = navigator,
      clipboard = _navigator.clipboard;
    if (clipboard !== undefined) {
      try {
        return yield navigator.clipboard.writeText(text);
      } catch (_unused) {
        // Ignore error. Fallback to `copyToClipboardExecCommand` below
        // (same as when clipboard is not available).
      }
    }
    copyToClipboardExecCommand(text);
  });
  return _copyToClipboard.apply(this, arguments);
}
export function copyToClipboardExecCommand(text) {
  var oldFocus = document.activeElement;
  var textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  var result = document.execCommand('copy');
  document.body.removeChild(textArea);
  if (oldFocus instanceof HTMLElement) {
    oldFocus.focus();
  }
  if (!result) throw new Error('Unable to execute copy command');
}

/**
 * Reads text from the clipboard.
 * @returns Promise that resolves to text from clipboard as string, or rejects if permissions are not supported/granted.
 */
export function readFromClipboard() {
  return _readFromClipboard.apply(this, arguments);
}
function _readFromClipboard() {
  _readFromClipboard = _asyncToGenerator(function* () {
    try {
      var _navigator2 = navigator,
        clipboard = _navigator2.clipboard;
      if (clipboard === undefined) throw new ClipboardUnavailableError();
      var permissionState = yield checkPermission('clipboard-read');
      if (permissionState === 'granted') {
        var text = yield clipboard.readText();
        return text;
      }
      if (permissionState === 'prompt') {
        try {
          // Need to call this to bring up a permission prompt
          yield clipboard.readText();
        } catch (_unused2) {
          // Ignore error caused by calling readText() without permissions
        }

        // Check status again after user has interacted with the permission prompt
        permissionState = yield checkPermission('clipboard-read');
        if (permissionState === 'granted') {
          var _text = yield clipboard.readText();
          return _text;
        }
      }
      if (permissionState === 'prompt' || permissionState === 'denied') {
        // Prompt means user closed out of the previous permission prompt, also treat it as a denial
        throw new ClipboardPermissionsDeniedError();
      }
    } catch (err) {
      if (err instanceof UnsupportedPermissionError) {
        throw new ClipboardUnavailableError();
      }
      throw err;
    }
    throw new ClipboardUnavailableError();
  });
  return _readFromClipboard.apply(this, arguments);
}
//# sourceMappingURL=ClipboardUtils.js.map